<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            name="titulo"
            v-model="formulario.titulo"
            placeholder="Título"
            data-vv-as="Título"
            v-validate="'required|max:255'"
            :error="validationErrors.first('titulo')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="text"
            name="url"
            v-model="formulario.url"
            placeholder="URL"
            data-vv-as="URL"
            v-validate="'required|max:255'"
            :error="validationErrors.first('url')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent
            name="metodo"
            v-model="formulario.metodo"
            :listaDeOptions="metodosHttp"
            :optionLabel="'nome'"
            :optionValue="'valor'"
            placeholder="Método HTTP"
            data-vv-as="Método"
            v-validate="'required'"
            :error="validationErrors.first('metodo')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent
            type="textarea"
            name="corpo"
            v-model="formulario.corpo"
            placeholder='Corpo do Formulário (JSON) - Exemplo: [{"campo": "valor"}]'
            data-vv-as="Corpo"
            v-validate="'required'"
            :error="validationErrors.first('corpo')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormularioCtrlFormulariosComponent',

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    formularioSelecionado: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  data () {
    return {
      formulario: {
        id: this.formularioSelecionado.id || null,
        titulo: this.formularioSelecionado.titulo || '',
        corpo: this.formularioSelecionado.corpo ? JSON.stringify(this.formularioSelecionado.corpo, null, 2) : '[]',
        url: this.formularioSelecionado.url || '',
        metodo: this.formularioSelecionado.metodo || ''
      },
      metodosHttp: [
        { nome: 'GET', valor: 'GET' },
        { nome: 'POST', valor: 'POST' },
        { nome: 'PUT', valor: 'PUT' },
        { nome: 'PATCH', valor: 'PATCH' },
        { nome: 'DELETE', valor: 'DELETE' }
      ]
    }
  },

  methods: {
    ...mapActions('ctrlFormularios', [
      'salvarFormulario',
      'atualizarFormulario'
    ]),

    async submit () {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      try {
        const formData = { ...this.formulario }
        
        // Validate JSON structure
        try {
          const parsedCorpo = JSON.parse(formData.corpo)
          
          // Validate if it's an array
          if (!Array.isArray(parsedCorpo)) {
            this.$toast.error('O corpo deve ser um array JSON válido')
            return
          }

          // Validate each object in the array has required structure
          const validObjects = parsedCorpo.every(item => {
            return typeof item === 'object' && item !== null
          })

          if (!validObjects) {
            this.$toast.error('Cada item do array deve ser um objeto válido')
            return
          }

          formData.corpo = parsedCorpo

        } catch (e) {
          this.$toast.error('JSON inválido: ' + e.message)
          return
        }

        if (this.tipoFormulario === 'salvar') {
          await this.salvarFormulario(formData)
        } else {
          await this.atualizarFormulario(formData)
        }

        this.limparCampos()
        this.fecharModal()

      } catch (e) {
        console.error('Erro ao processar formulário:', e)
        this.$toast.error('Erro ao salvar formulário')
      }
    },

    limparCampos () {
      this.formulario = {
        titulo: '',
        corpo: '[]',
        url: '',
        metodo: ''
      }
      this.$validator.reset()
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>